import { render, staticRenderFns } from "./inclusion.vue?vue&type=template&id=71fb03c4&scoped=true&"
import script from "./inclusion.vue?vue&type=script&lang=js&"
export * from "./inclusion.vue?vue&type=script&lang=js&"
import style0 from "./inclusion.vue?vue&type=style&index=0&id=71fb03c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb03c4",
  null
  
)

export default component.exports